import { FiFile } from "@/lib/icons"

// Translations
import { useTrans } from "@/i18n"

// UI
import { Anchor } from "@/components/Anchor"
import { Card } from "@/components/Card"
import { Heading } from "@/components/Typography"
import { Tooltip } from "@/components/tooltips/Tooltip"

// Hooks
import { useCurrentProject } from "../hooks"

// Environment variables
import { EXTERNAL_PLATFORM_ZONHUB_INVESTMENT_CERTIFICATE } from "@/lib/env"

/**
 * ProjectDocumentation
 * @returns
 */
export const ProjectDocumentation = () => {
	const t = useTrans("project")
	const { data } = useCurrentProject()

	return (
		<>
			<title>
				{t("common:common.web.title", {
					page: t("project:project.documentation.page_title", {
						projectName: data?.project?.name,
					}),
				})}
			</title>
			<div className="space-y-6">
				<Card className="xl:w-3/5">
					<Heading as="h5" className="mb-3 sm:truncate">
						{t("project:project.documentation.page_title", {
							projectName: data?.project?.name,
						})}
					</Heading>
					<p
						className="text-sm text-gray-500"
						data-testid="project.documentation.copy"
					>
						{t("project:project.documentation.copy")}
					</p>
				</Card>
				<Card className="xl:w-3/5">
					<Heading as="h5" className="mb-3 sm:truncate">
						{t("project:project.documentation.downloads_heading")}
					</Heading>
					<div className="grid gap-2">
						{/** Bonds certificates */}
						<div className="flex">
							<Anchor
								href={String(
									`${EXTERNAL_PLATFORM_ZONHUB_INVESTMENT_CERTIFICATE}${data?.project?.id}`,
								)}
								target="_blank"
								download
								className="flex items-center text-sm font-medium text-secondary-300 hover:text-secondary-900"
							>
								<FiFile className="mr-2" />
								{t(
									"project:project.documentation.solar_bonds_certificate.title",
								)}
							</Anchor>
						</div>

						{/** Documents */}
						{data?.project?.documents?.map((document) => {
							return (
								<div
									className="flex"
									key={String(document!.url)}
								>
									<Anchor
										href={String(document!.url)}
										target="_blank"
										download
										className="flex items-center text-sm font-medium text-secondary-300 hover:text-secondary-900"
									>
										<FiFile className="mr-2" />
										{document!.title}
									</Anchor>
									{!!document?.description?.length && (
										<Tooltip
											text={document.description}
											targetClassNamesProp={
												"text-gray-500"
											}
										/>
									)}
								</div>
							)
						})}
					</div>
				</Card>
			</div>
		</>
	)
}
